import { $, $$ } from 'utils/dom';
import { createFocusTrap } from 'focus-trap';

export default class FocusTrap {
  constructor(handler, target, closeButton) {
    this.handler = handler;
    this.target = target;
    this.closeButton = closeButton;
    this.focusTrap = null;
    this.focusTrapActive = false;
    this.links = $$('a', target);
    this.clickedElement = null;
  }

  initializeFocusTrap() {
    this.focusTrap = createFocusTrap(this.target, {
      allowOutsideClick: () => {
        this.focusTrap.deactivate();
        this.focusTrapActive = false;
        this.focusTrap = null;

        return true;
      },

      checkCanFocusTrap: trapContainers => {
        const results = trapContainers.map(trapContainer => {
          return new Promise(resolve => {
            const interval = setInterval(() => {
              if (trapContainer.getAttribute('aria-hidden') === 'false') {
                resolve();
                clearInterval(interval);
              }
            }, 1);
          });
        });
        return Promise.all(results);
      },

      escapeDeactivates: false,

      onActivate: () => {
        this.focusTrapActive = true;
        this.target.classList.add('has-focus-active');
      },

      onDeactivate: () => {
        this.focusTrapActive = false;
        this.target.classList.remove('has-focus-active');
      },

      setReturnFocus: () => {
        if (this.clickedElement) {
          const hasHref = this.clickedElement.getAttribute('href');
          if (hasHref && hasHref.startsWith('#')) {
            const element = $(this.clickedElement.getAttribute('href'));
            element.setAttribute('tabindex', 0);
            element.focus();

            return element;
          }
        }

        return true;
      },
    });
  }

  activateFocusTrap() {
    this.initializeFocusTrap();
    this.focusTrap.activate();
  }

  deactivateFocusTrap(event) {
    this.clickedElement = event.target;
    this.focusTrap.deactivate();
    this.focusTrap = null;
  }

  setUpListeners() {
    this.handler.addEventListener('keydown', event => {
      if (event.key === 'Enter') {
        if (
          !this.focusTrapActive &&
          !this.handler.classList.contains('is-open')
        ) {
          this.activateFocusTrap();
        }
      }
      if (event.key === 'Escape') {
        if (this.focusTrapActive) {
          this.deactivateFocusTrap(event);
        }
      }
    });

    this.closeButton.addEventListener('keydown', event => {
      if (event.key === 'Enter') {
        if (this.focusTrapActive) {
          this.deactivateFocusTrap(event);
        }
      }
    });

    this.target.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        if (this.focusTrapActive) {
          this.deactivateFocusTrap(event);
        }
      }
    });

    this.closeButton.addEventListener('click', event => {
      if (this.focusTrapActive) {
        this.deactivateFocusTrap(event);
      }
    });

    this.links.forEach(link => {
      link.addEventListener('click', event => {
        if (this.focusTrapActive) {
          this.deactivateFocusTrap(event);
        }
      });
    });
  }

  init = () => {
    this.setUpListeners();
  };
}
